import React from 'react';
import { Link } from 'react-router-dom';
import './BackButton.css';

function BackButton() {
  return (
    <div className="back-bar">
      <Link to="/" className="back-link">&larr; Back to Home</Link>
    </div>
  );
}

export default BackButton;
